import { useId, useRef } from 'react';
import { X } from 'lucide-react';

export function ContentEditorPanel({ title, tabs, activeTab, onTabChange, onClose, children, side = 'left', showHeader = true }) {
  const id = useId();
  const buttons = useRef([]);
  const move = (event, index) => {
    let next;
    if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
    else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    else return;
    event.preventDefault();
    onTabChange(tabs[next].id);
    buttons.current[next]?.focus();
  };
  return <div className={`mts-editor-navigation-panel mts-editor-panel-${side}`} aria-label={title}>
    {showHeader ? <header className="mts-editor-panel-header"><strong>{title}</strong><button type="button" aria-label={`Close ${title.toLowerCase()}`} onClick={onClose}><X size={18} aria-hidden="true"/></button></header> : null}
    <div role="tablist" aria-label={`${title} sections`} className="mts-editor-panel-tabs">
      {tabs.map((tab, index) => <button key={tab.id} ref={element => { buttons.current[index] = element; }} type="button" role="tab" id={`${id}-${tab.id}`} aria-controls={`${id}-body`} aria-selected={tab.id === activeTab} tabIndex={tab.id === activeTab ? 0 : -1} onKeyDown={event => move(event, index)} onClick={() => onTabChange(tab.id)}>{tab.label}</button>)}
    </div>
    <div role="tabpanel" id={`${id}-body`} aria-labelledby={`${id}-${activeTab}`} className="mts-editor-panel-body">{children}</div>
  </div>;
}
